import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

interface SchadenKICredentials {
  apiKey: string;
  apiUrl: string;
}

export async function getSchadenKICredentials(): Promise<SchadenKICredentials> {
  try {
    const data = await authenticatedFetchJson<SchadenKICredentials>("/api/schaden-ki-credentials", {
      method: "GET",
    });

    return {
      apiKey: data.apiKey || "",
      apiUrl: data.apiUrl || ""
    };
  } catch (error) {
    console.error("Error fetching Schaden KI credentials:", error);
    return { apiKey: "", apiUrl: "" };
  }
}

